import axios from 'axios'
import React from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { Alert } from '@apex/component-library'
import { useToast } from '@chakra-ui/react'
import { getAppConfigSetting } from '../utils'
import { SCHEDULED_TRANSFERS } from './constants'
import queryKeys from './queryKeys'

export type CancelScheduleTransfer = { comment?: string; transferType: string; scheduleId: string }

export const buildApiUrl = (type: string, id: string) => {
  const baseUrl = getAppConfigSetting('apiUrl')
  return `${baseUrl}${SCHEDULED_TRANSFERS}/${type}/${id}/cancel`
}

export const putCancelScheduleTransfer = async ({
  comment,
  transferType,
  scheduleId
}: CancelScheduleTransfer): Promise<any> => {
  const cancelScheduleTransferURL = buildApiUrl(transferType, scheduleId)
  const payload = { comment }
  const { data } = await axios.put(cancelScheduleTransferURL, payload, {
    withCredentials: true
  })
  return data
}
interface CancelProps {
  onSettled: () => void
}

export const useCancelScheduleTransfer = () => {
  const queryClient = useQueryClient()
  const toast = useToast()
  return useMutation(putCancelScheduleTransfer, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.scheduledTransfers)
      toast({
        duration: 5000,
        position: 'top-right',
        variant: 'left-accent',
        status: 'success',
        isClosable: true,
        render: ({ onClose, id }) => (
          <Alert
            sx={{
              width: 340,
              color: 'black',
              bg: 'white',
              boxShadow: '0px 0px 5px 3px rgba(153,153,153,0.5)'
            }}
            direction='column'
            variant='left-accent'
            title='Success!'
            description='Your transfer schedule has been canceled.'
            status='success'
            isClosable
            dismiss={onClose}
            id={id as string}
          />
        )
      })
    }
  })
}
